module.exports = "/_next/static/files/4e5020899469449b21f27c8887f6d974.png";